// Every request that populates a search-indexed collection reports its outcome here.
// `expected` is what the server says the collection holds (the x-total-count header),
// which is the only way to tell a fully loaded index from a partially loaded one.
//
// collection: 'sets' | 'questions' | 'folders' | 'repos'
// request:    'own' | 'allRepos'   (the two calls whose results are merged)

export function libraryLoadSucceeded(collection, request, expected) {
  return {
    type: 'LIBRARY_LOAD_STATUS', collection, request, ok: true, expected,
  }
}

export function libraryLoadFailed(collection, request) {
  return {
    type: 'LIBRARY_LOAD_STATUS', collection, request, ok: false, expected: null,
  }
}

// A delta request only returns records changed since the last refresh, so its own
// x-total-count says nothing about the size of the collection. The count is fetched
// separately and reported here, which must not disturb the load outcome.
export function libraryExpectedCount(collection, request, expected) {
  return {
    type: 'LIBRARY_LOAD_EXPECTED', collection, request, expected,
  }
}
